import * as React from 'react';
import cx from 'classnames';
import { Header3 } from 'components/typography';
import {
    Category as CategoryType,
    Post,
} from 'interfaces/bumble-seasonal-content-hub-microsite-cms';
import { basePathIndexUrl } from 'lib/schemes';
import CtaBoxCaption, { CtaBoxCaptionAlign } from 'components/cta-box/cta-box-caption';
import CtaBox, { CtaBoxAlign } from 'components/cta-box/cta-box';
import Link from 'components/link/link';

export type CategoryEdgePostEdge = {
    node: Post & {
        postFieldGroup: {
            ctaText: string;
            ctaUrl: string;
        };
    };
};

export type CategoryEdge = {
    node: CategoryType & {
        postCategoryFieldGroup: {
            order: number;
            backgroundcolor?: string;
            ctaText: string;
            ctaUrl: string;
            showonmainpage: boolean;
        };
        posts: {
            edges: CategoryEdgePostEdge[];
        };
    };
};

export type CategoryPostItem = {
    node: Post & {
        postFieldGroup: {
            ctaText: string;
            ctaUrl: string;
        };
    };
};

type CategoryProps = {
    titleUrl?: string;
    breadcrumbs?: React.ReactNode;
    cta?: React.ReactNode;
    loader?: React.ReactNode;
    name?: string;
    slug?: string;
    edges?: CategoryEdge[] | React.ReactNode[];
    ctaUrl?: string;
    ctaText?: string;
    backgroundColor?: string;
    hasOneRow?: boolean;
    isRelatedArticles?: boolean;
};

export function Category({
    titleUrl,
    breadcrumbs,
    name,
    slug,
    edges,
    backgroundColor,
    hasOneRow,
    cta,
    loader,
    isRelatedArticles,
}: CategoryProps) {
    const className = cx({
        category: true,
        'category--one-row': hasOneRow,
        'category--related-articles': isRelatedArticles,
        [`category--${name?.toLocaleLowerCase()}`]: name,
    });

    const title = isRelatedArticles ? `More ${name} Date Ideas` : name;
    const url =
        titleUrl || slug?.startsWith(basePathIndexUrl) ? `${slug}` : `${basePathIndexUrl}/${slug}`;

    return (
        <div
            className={className}
            style={{
                backgroundColor,
            }}
        >
            <div className="category__breadcrumbs">{breadcrumbs}</div>
            <div className="category__header">
                <Header3>
                    <Link href={url}>{title}</Link>
                </Header3>
            </div>
            <div className="category__content">
                <div className="category__cards">{edges as React.ReactNode[]}</div>
            </div>

            {loader ? <div className="category__cta">{loader}</div> : null}

            {cta ? (
                <div className="category__cta">
                    <CtaBox align={CtaBoxAlign.CENTERED}>
                        <CtaBoxCaption align={CtaBoxCaptionAlign.CENTERED}>
                            <>{cta}</>
                        </CtaBoxCaption>
                    </CtaBox>
                </div>
            ) : null}
        </div>
    );
}
